import { useState } from 'react';

export const useCompanyFilter = ({ companyDomain, setFilters }) => {
  const [isBulkMode, setIsBulkMode] = useState(() => companyDomain?.length > 0);

  const handleToggleBulkMode = () => {
    const newIsBulkMode = !isBulkMode;
    setIsBulkMode(newIsBulkMode);

    // Clean up filters when switching modes
    if (newIsBulkMode) {
      // Switching to bulk mode (company domain) - clean companyName and related filters
      setFilters({
        companyName: [],
        companyNameIncluded: null,
        companyNamePeriod: null,
      });
    } else {
      // Switching to regular mode (company name) - clean companyDomain and related filters
      setFilters({
        companyDomain: [],
        companyNameIncluded: null,
        companyNamePeriod: null,
      });
    }
  };

  return {
    isBulkMode,
    handleToggleBulkMode,
  };
};
